import { StrategyIds, type strategyConfigType } from '$lib/types/strategy';

const longConfig = { platform: 'Aave', logo_url: 'tokens/aave.svg', type: 'Spot' };
const shortConfig = {
	platform: 'Polynomial',
	logo_url: 'Logo.webp',
	type: 'Perp'
};

export let strategyConfig: Record<string, strategyConfigType> = {
	[StrategyIds.ETH]: {
		aave_collateral_token_address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
		asset: 'Ethereum',
		asset_symbol: 'ETH',
		asset_logo: 'tokens/ethereum.png',
		marketIdentifier: 'sETHPERP',
		longConfig,
		shortConfig
	},
	[StrategyIds.OP]: {
		aave_collateral_token_address: '0x4200000000000000000000000000000000000042',
		asset: 'Optimism',
		asset_symbol: 'OP',
		asset_logo: 'tokens/optimism.svg',
		marketIdentifier: 'sOPPERP',
		longConfig,
		shortConfig
	},
	[StrategyIds.LINK]: {
		aave_collateral_token_address: '0x350a791bfc2c21f9ed5d10980dad2e2638ffa7f6',
		asset: 'Link',
		asset_symbol: 'LINK',
		asset_logo: 'tokens/chainlink.svg',
		marketIdentifier: 'sLINKPERP',
		longConfig,
		shortConfig
	},
	[StrategyIds.AAVE]: {
		aave_collateral_token_address: '0x76fb31fb4af56892a25e32cfc43de717950c9278',
		asset: 'Aave',
		asset_symbol: 'AAVE',
		asset_logo: 'tokens/aave.svg',
		marketIdentifier: 'sAAVEPERP',
		longConfig,
		shortConfig
	}
};
